import ResourceClient from "dea-bookmarks-clients/src/clients/resources";
import utils from "deascuola-storybook/src/components/mixins/utils";

const state = {
  bookObjects: [],
  postObjects: [],
  eventObjects: [],
  resourceObjects: [],
  resourceFilters: {},
  resourceObjectsFiltered: [],
  eventObjectsFiltered: [],
  bookmarksLoaded: false,
  bookmarksAvailable: false,
};

const getters = {
  bookObjects: moduleState => moduleState.bookObjects,
  postObjects: moduleState => moduleState.postObjects,
  eventObjects: moduleState => moduleState.eventObjects,
  resourceObjects: moduleState => moduleState.resourceObjects,
  resourceFilters: moduleState => moduleState.resourceFilters,
  resourceObjectsFiltered: moduleState => moduleState.resourceObjectsFiltered,
  eventObjectsFiltered: moduleState => moduleState.eventObjectsFiltered,
  bookmarksLoaded: moduleState => moduleState.bookmarksLoaded,
  bookmarksAvailable: moduleState => moduleState.bookmarksAvailable,
  books: moduleState => moduleState.bookObjects.map(item => item.books),
  resources: moduleState => moduleState.resourceObjects.map(item => item.payload),
  posts: moduleState => moduleState.postObjects.map(item => item.payload),
  events: moduleState => moduleState.eventObjects.map(item => item.payload),
  resourcesFiltered: moduleState => moduleState.resourceObjectsFiltered.map(item => item.payload),
  eventsFiltered: moduleState => moduleState.eventObjectsFiltered.map(item => item.payload),
  allBookmarks: moduleState => {
    const allBookmarks = [...moduleState.postObjects, ...moduleState.eventObjects, ...moduleState.resourceObjects];
    return allBookmarks.sort((a, b) => {
      return a.created - b.created;
    });
  },
};

const actions = {
  async fetchBookmarks({ commit, rootState }, token) {
    try {
      const all = await ResourceClient.getAll(token);
      if (all.events) commit("setEvents", all.events);
      if (all.books) commit("setBooks", all.books);
      if (all.events) commit("setEventsFiltered", all.events);
      if (all.posts) commit("setDeaLive", all.posts);
      if (all.resources) commit("setResources", all.resources);
      if (all.resources) commit("setResourcesFiltered", all.resources);
      commit("setBookmarksLoaded", true);
      commit("setBookmarksAvailable", true);
    } catch (e) {
      commit("setBookmarksLoaded", true);
      if (e.response && e.response.status === 403) utils.redirectToLogin(null, rootState.config);
    }
  },
  async fetchBooks({ commit, rootState }, token) {
    try {
      const books = await ResourceClient.getBooks(token);
      commit("setBooks", books);
    } catch (e) {
      if (e.response && e.response.status === 403) utils.redirectToLogin(null, rootState.config);
    }
  },
  async fetchEvents({ commit, rootState }, token) {
    try {
      const events = await ResourceClient.getEvents(token);
      commit("setEvents", events);
    } catch (e) {
      if (e.response && e.response.status === 403) utils.redirectToLogin(null, rootState.config);
    }
  },
  async fetchDeaLive({ commit, rootState }, token) {
    try {
      const posts = await ResourceClient.getDeaLive(token);
      commit("setDeaLive", posts);
    } catch (e) {
      if (e.response && e.response.status === 403) utils.redirectToLogin(null, rootState.config);
    }
  },
  async fetchResources({ commit, rootState }, token) {
    try {
      const resources = await ResourceClient.getResources(token);
      commit("setResources", resources);
    } catch (e) {
      if (e.response && e.response.status === 403) utils.redirectToLogin(null, rootState.config);
    }
  },
  // eslint-disable-next-line no-shadow
  filterResource({ commit, getters }, { filterFacet, filterValue }) {
    const filters = getters.resourceFilters;
    filters[filterFacet] = filterValue;
    let filtered = getters.resourceObjects;
    Object.keys(filters).forEach(facet => {
      const value = filters[facet];
      if (facet === "type_label" && value && value.length)
        filtered = filtered.filter(item => value.indexOf(item.payload.type_label) > -1);
      if (facet === "origin" && value && value.length)
        filtered = filtered.filter(
          item => item.data_from && value.indexOf(item.data_from.label.toLowerCase().replace(/ /gi, "")) > -1
        );
      if (facet === "title" && value)
        filtered = filtered.filter(item => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1);
      if (facet === "dates" && value)
        filtered = filtered.filter(item => {
          const startDate = !value.startDate || new Date(item.created_at) >= new Date(value.startDate);
          const endDate = !value.endDate || new Date(item.created_at) <= new Date(value.endDate);
          return startDate && endDate;
        });
    });
    commit("setResourceFilters", filters);
    commit("setResourcesFiltered", filtered);
  },
  // eslint-disable-next-line no-shadow
  filterEventsByType({ commit, getters }, value) {
    let filtered = getters.eventObjects;
    if (value) filtered = filtered.filter(item => item.payload.type === value);
    commit("setEventsFiltered", filtered);
  },
};

/* eslint-disable no-param-reassign,no-return-assign */
const mutations = {
  setResourceFilters: (oldState, filters) => (oldState.resourceFilters = filters),
  setResources: (oldState, resources) => (oldState.resourceObjects = resources),
  setBooks: (oldState, books) => (oldState.bookObjects = books),
  setResourcesFiltered: (oldState, resources) => (oldState.resourceObjectsFiltered = resources),
  setDeaLive: (oldState, posts) => (oldState.postObjects = posts),
  setEvents: (oldState, events) => (oldState.eventObjects = events),
  setEventsFiltered: (oldState, events) => (oldState.eventObjectsFiltered = events),
  setBookmarksLoaded: (oldState, token) => (oldState.bookmarksLoaded = token),
  setBookmarksAvailable: (oldState, token) => (oldState.bookmarksAvailable = token),
  removeItem: (oldstate, { type, bookmark }) => {
    // filter out removed bookmark id
    oldstate[`${type}Objects`] = oldstate[`${type}Objects`].filter(item => item.id !== bookmark.id);
  },
  addItem: (oldstate, { type, bookmark }) => {
    oldstate[`${type}Objects`].push(bookmark);
  },
  /* eslint-enable no-param-reassign,no-return-assign */
};
export default {
  state,
  getters,
  actions,
  mutations,
};
